import { createContext, useContext } from "react";

// The auth context object lives apart from the provider so light readers (theme, Calm)
// don't pull in the supabase client.
export const AuthContext = createContext(null);

export function useOptionalAuth() {
  return useContext(AuthContext);
}
